/* unplugin-vue-components disabled */import { render } from "./TeachingPlanView.vue?vue&type=template&id=94fbbae2&scoped=true"
import script from "./TeachingPlanView.vue?vue&type=script&lang=js"
export * from "./TeachingPlanView.vue?vue&type=script&lang=js"

import "./TeachingPlanView.vue?vue&type=style&index=0&id=94fbbae2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94fbbae2"]])

export default __exports__